<template>
  <v-row dense>
    <v-col>
      <v-row dense>
        <v-col class="text-h5 gray--text">
          {{ attendancePlace.name }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-btn icon @click="toggleAttendancePlace(attendancePlace)">
            <v-icon v-if="showList">eva-arrow-ios-upward-outline</v-icon>
            <v-icon v-else>eva-arrow-ios-downward-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="showList">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="employeeAttendancePlaces"
            sort-by="name"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-dialog
                  v-model="dialog"
                  max-width="500px"
                  @click:outside="close"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                      adicionar médico
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container fluid>
                        <v-row dense>
                          <v-col>
                            <v-combobox
                              outlined
                              dense
                              v-model="editedItem.employee"
                              label="Médico"
                              :items="ordenedDoctors"
                              item-text="name"
                              :hide-details="errors.employee === undefined"
                              :error-messages="errors.employee"
                            />
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col>
                            <v-text-field
                              outlined
                              dense
                              v-model="editedItem.scheduleFor"
                              label="Agendado para"
                              v-mask="'##/##/#### ##:##'"
                              placeholder="dd/MM/aaaa HH:mm"
                              :hide-details="errors.scheduleFor === undefined"
                              :error-messages="errors.scheduleFor"
                            />
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col>
                            <v-text-field
                              outlined
                              dense
                              clearable
                              v-model="editedItem.scheduleEnd"
                              label="Fim agendamento"
                              v-mask="'##/##/#### ##:##'"
                              placeholder="dd/MM/aaaa HH:mm"
                              :hide-details="errors.scheduleEnd === undefined"
                              :error-messages="errors.scheduleEnd"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="blue darken-1" text @click="close">
                        Cancelar
                      </v-btn>

                      <v-btn color="blue darken-1" text @click="save">
                        Salvar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.scheduleFor="{ item }">
              {{
                $moment(item.scheduleFor, "YYYY-MM-DD HH:mm:ss ZZ")
                  | moment("DD/MM/Y HH:mm")
              }}
            </template>

            <template v-slot:item.scheduleEnd="{ item }">
              <span v-if="item.scheduleEnd">
                {{
                  $moment(item.scheduleEnd, "YYYY-MM-DD HH:mm:ss ZZ")
                    | moment("DD/MM/Y HH:mm")
                }}
              </span>

              <span v-else> por tempo indeterminado </span>
            </template>

            <template v-slot:item.actions="{ item }">
              <authorization
                permissionKey="configuration_facilitator_hma"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-icon
                  v-if="authorization"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  eva-edit-outline
                </v-icon>
              </authorization>
            </template>

            <template v-slot:no-data>
              <v-alert color="orange" outlined text type="info">
                Não há nenhum medico nesse consultório
              </v-alert>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "EmployeeAttendancePlaceList",
  props: {
    attendancePlace: Object,
    toggleAttendancePlace: Function,
    employees: Array,
    showList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: {},
      headers: [
        { text: "Nome", value: "employee.name" },
        { text: "Agendado para", value: "scheduleFor" },
        { text: "Fim agendamento", value: "scheduleEnd" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
      dialog: null,
      editedItem: {},
      editedIndex: -1,
    };
  },
  apollo: {
    employeeAttendancePlaces: {
      query: require("@/graphql/employees/attendance_places.gql"),
      variables() {
        return {
          attendancePlaceId: this.attendancePlace.id,
        };
      },
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nova reserva de consultório"
        : "Editar reserva de consultório";
    },
    ordenedDoctors() {
      if (!this.employees) return;
      return this.lodash.orderBy(
        this.employees,
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.employeeAttendancePlaces.indexOf(item);

      this.editedItem = Object.assign({}, item);
      this.editedItem.scheduleFor = this.$moment(
        new Date(this.editedItem.scheduleFor)
      ).format("DD/MM/YYYY HH:mm");

      if (this.editedItem.scheduleEnd) {
        this.editedItem.scheduleEnd = this.$moment(
          new Date(this.editedItem.scheduleEnd)
        ).format("DD/MM/YYYY HH:mm");
      }

      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.errors = {};

      if (!this.editedItem.employee?.id) {
        this.errors.employee = "Esse campo deve ser preenchido.";
      }

      let scheduleFor = this.$moment(
        this.editedItem.scheduleFor,
        "DD/MM/YYYY HH:mm"
      );
      if (!scheduleFor.isValid()) {
        this.errors.scheduleFor = "Data invalida.";
      }
      scheduleFor = scheduleFor.format("YYYY-MM-DDTHH:mm");

      let scheduleEnd = this.editedItem.scheduleEnd;
      if (scheduleEnd) {
        scheduleEnd = this.$moment(
          this.editedItem.scheduleEnd,
          "DD/MM/YYYY HH:mm"
        );
        if (!scheduleEnd.isValid()) {
          this.errors.scheduleEnd = "Data invalida.";
        }
        scheduleEnd = scheduleEnd.format("YYYY-MM-DDTHH:mm");
      }

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      this.apolloMutate({
        mutation: require("@/graphql/employee_attendance_place/save_employee_attendance_place.gql"),
        variables: {
          employeeAttendancePlaceId: this.lodash.get(this.editedItem, "id", ""),
          attendancePlaceId: this.attendancePlace.id,
          employeeId: this.editedItem.employee.id,
          scheduleFor: scheduleFor,
          scheduleEnd: scheduleEnd,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      this.$apollo.queries.employeeAttendancePlaces.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
